import OLClient from '../../api/clients/shared/OLClient';
import SpellingClient from '../../api/clients/shared/SpellingClient';
import VocaboClient from '../../api/clients/shared/VocaboClient';
import { MEASURE, VOCABO_MEASURE } from '../../constants/shared/MeasuresConstants';

const { SPELLING, OL } = MEASURE;
const { TQVM, FITB, BD } = VOCABO_MEASURE;

const sharedGetClient = (measure, defaultClient) => {
    switch (measure) {
        case TQVM:
        case FITB:
        case BD:
            return VocaboClient;
        case SPELLING:
            return SpellingClient;
        case OL:
            return OLClient;
        default:
            return defaultClient;
    }
};

export default sharedGetClient;
